import React from "react";

export const layout1 = (
    <svg id="Layer_1" width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <rect x="1" y="1" width="28" height="28" />
    </svg>

);

export const layout2 = (
    <svg id="Layer_1" width={18} fill="currentColor" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <g id="Layer_2" data-name="Layer 2">
            <g id="icons">
                <g id="icon_unchecked" data-name="icon unchecked">
                    <rect x="1.01" y="1" width="13.5" height="13.5" />
                </g>
            </g>
        </g>
        <g id="Layer_2-2" data-name="Layer 2">
            <g id="icons-2" data-name="icons">
                <g id="icon_unchecked-2" data-name="icon unchecked">
                    <rect x="15.51" y="1" width="13.5" height="13.5" />
                </g>
            </g>
        </g>
        <g id="Layer_2-3" data-name="Layer 2">
            <g id="icons-3" data-name="icons">
                <g id="icon_unchecked-3" data-name="icon unchecked">
                    <rect x="1.01" y="15.5" width="13.5" height="13.5" />
                </g>
            </g>
        </g>
        <g id="Layer_2-4" data-name="Layer 2">
            <g id="icons-4" data-name="icons">
                <g id="icon_unchecked-4" data-name="icon unchecked">
                    <rect x="15.51" y="15.5" width="13.5" height="13.5" />
                </g>
            </g>
        </g>
    </svg>

);

export const layout3 = (
    <svg id="Layer_1" width={18} fill="currentColor" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <g id="Layer_2" data-name="Layer 2">
            <g id="icons">
                <g id="icon_unchecked" data-name="icon unchecked">
                    <rect x="1" y="1.01" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-2" data-name="Layer 2">
            <g id="icons-2" data-name="icons">
                <g id="icon_unchecked-2" data-name="icon unchecked">
                    <rect x="10.66" y="1.01" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-3" data-name="Layer 2">
            <g id="icons-3" data-name="icons">
                <g id="icon_unchecked-3" data-name="icon unchecked">
                    <rect x="20.32" y="1" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-4" data-name="Layer 2">
            <g id="icons-4" data-name="icons">
                <g id="icon_unchecked-4" data-name="icon unchecked">
                    <rect x=".99" y="10.68" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-5" data-name="Layer 2">
            <g id="icons-5" data-name="icons">
                <g id="icon_unchecked-5" data-name="icon unchecked">
                    <rect x="10.66" y="10.67" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-6" data-name="Layer 2">
            <g id="icons-6" data-name="icons">
                <g id="icon_unchecked-6" data-name="icon unchecked">
                    <rect x="20.33" y="10.67" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-7" data-name="Layer 2">
            <g id="icons-7" data-name="icons">
                <g id="icon_unchecked-7" data-name="icon unchecked">
                    <rect x="20.33" y="20.33" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-8" data-name="Layer 2">
            <g id="icons-8" data-name="icons">
                <g id="icon_unchecked-8" data-name="icon unchecked">
                    <rect x="10.66" y="20.33" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
        <g id="Layer_2-9" data-name="Layer 2">
            <g id="icons-9" data-name="icons">
                <g id="icon_unchecked-9" data-name="icon unchecked">
                    <rect x="1.02" y="20.32" width="8.66" height="8.66" />
                </g>
            </g>
        </g>
    </svg>
);

export const layout4 = (
    <svg id="Layer_1" width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <g>
            <rect x="1" y="1" width="6" height="28" />
            <rect x="8" y="1" width="6" height="28" />
            <rect x="15" y="1" width="6" height="28" />
            <rect x="22" y="1" width="6" height="28" />
        </g>
    </svg>

);

export const layout6 = (
    <svg id="Layer_1" width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
        <g>
            <rect x="1" y="1" width="28" height="5" />
            <rect x="1" y="7" width="28" height="5" />
            <rect x="1" y="13" width="28" height="5" />
            <rect x="1" y="19" width="28" height="5" />
            <rect x="1" y="25" width="28" height="5" />
        </g>
    </svg>

);

export const close = (
    <svg
        aria-hidden="true"
        focusable="false"
        fill="none"
        width="15"
        viewBox="0 0 16 16"
    >
        <path
            d="m1 1 14 14M1 15 15 1"
            stroke="currentColor"
            strokeWidth="1.5px"
        />
    </svg>
);

export const chevronRight = (
    <svg fill="none" width="15px" viewBox="0 0 10 10">
        <path d="M7 1 3 5l4 4" stroke="currentColor" strokeLinecap="square" />
    </svg>
);

export const chevronLeft = (
    <svg fill="none" width="15px" viewBox="0 0 10 10">
        <path d="m3 9 4-4-4-4" stroke="currentColor" strokeLinecap="square" />
    </svg>
);

export const chevronDown = (
    <svg aria-hidden="true" focusable="false" fill="none" width="15px" viewBox="0 0 10 10">
        <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square" />
    </svg>
)

export const wishlistIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="wishlist-heart-icon" width="18" height="18">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
    </svg>
);

export const search = (
    <svg aria-hidden="true" fill="none" focusable="false" width="20" viewBox="0 0 24 24">
        <path
            d="M10.364 3a7.364 7.364 0 1 0 0 14.727 7.364 7.364 0 0 0 0-14.727Z"
            stroke="currentColor"
            strokeWidth="1px"
            strokeMiterlimit="10"
        />
        <path
            d="M15.857 15.858 21 21.001"
            stroke="currentColor"
            strokeWidth="1px"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
    </svg>
);
